import ErrorStackParser from 'error-stack-parser';
import StackTraceGPS from 'stacktrace-gps';

/**
 * Parse an error's stack trace and map frames to original source locations.
 * @param {Error} error
 * @returns {Promise<object[]>} Mapped stack frames.
 */
export const parseErrorFrames = async (error) => {
    const frames = ErrorStackParser.parse(error);
    const gps = new StackTraceGPS();
    return Promise.all(
        frames.slice(0, 5).map(frame =>
            gps.pinpoint(frame).then(stackFrame => ({
                ...stackFrame,
                // WAF rules will block any requests containing file paths starting with `../`
                fileName: stackFrame.fileName.replace(/^\.\.\//g, '/')
            })).catch(() => ({ error: 'error mapping frame' }))
        )
    );
};
